import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import type { PapiNetworkbarStrip } from '@wix/da-papi-types';
import { ThemeSurface } from '@wix/da-react-context/pkg/constants';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { FacetButton } from '@wix/da-ds/pkg/FacetList/Facet';
import Surface from '@wix/da-ds/pkg/Surface';
import s from './PopularTopicsStrip.scss';
import commonStyles from '../../common.scss';

interface Props {
  strip: PapiNetworkbarStrip;
  className?: string;
}

const PopularTopicsStrip: React.FC<Props> = ({ strip, className }) => {
  const { t } = useTranslation();
  return (
    <Surface
      elevation={ThemeSurface.PRIMARY}
      className={c(
        s['root'],
        commonStyles['section-horizontal-sizing'],
        className
      )}
    >
      <Section className={c(s['content'])}>
        <Heading className={s['heading']}>
          {t('shopPage.sellYourArt.strips.popularTopics.heading')}
        </Heading>
        <div className={s['topics']}>
          {strip.topNecos?.map(topic => (
            <FacetButton key={topic.itemId} size="large" href={topic.url}>
              {topic.name}
            </FacetButton>
          ))}
        </div>
      </Section>
    </Surface>
  );
};

PopularTopicsStrip.displayName = 'PopularTopicsStrip';

export default PopularTopicsStrip;
